import React from 'react';
import PropTypes from 'prop-types';
import {LanguageEditLayoutTemplate} from 'themes/layouts';
import { BaseViewStore, TranslationStore } from 'core/stores';
import _ from 'lodash';
import { useStores } from 'core/stores/StoreContext';

const LanguageEditLayout = (props) => {
    const rootStore = useStores();
    // recreated each render, mirroring the original (store snapshots form/item props)
    const store = new LanguageEditLayoutViewStore(rootStore, props);

    return (
        <LanguageEditLayoutTemplate
            store={store}
            {...props}
            rootStore={rootStore} />
    );
};

LanguageEditLayout.propTypes = {
    store: PropTypes.object, //LanguageEditLayoutViewStore
    form: PropTypes.object.isRequired,
    item: PropTypes.object,
    loaderStore: PropTypes.object,
    routeBack: PropTypes.func,
    rootStore: PropTypes.object
};

class LanguageEditLayoutViewStore extends BaseViewStore {
    constructor(rootStore, props) {
        super(rootStore);

        const { form, item } = props;

        this.translationStore = new TranslationStore(
            rootStore,
            { ..._.cloneDeep(form.getLocalizeFields()) },
            item
        );

        this.onSuccess = () => {
            const values = this.translationStore.applyMetadata(item);
            form.$hooks.onSuccess({
                ...item,
                languageMetadata: values
            })
        }
    }
}

export default LanguageEditLayout;
